// Tooltip hodnoty — vždy 2 desatinné miesta
export const NUM_FMT = new Intl.NumberFormat('sk-SK', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

// Popisky osí — max 2 desatinné miesta, bez zbytočných núl (1 000, nie 1 000,00)
export const AXIS_FMT = new Intl.NumberFormat('sk-SK', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
})

export function formatChartTooltip(v: number, unit: string): string {
  const formatted = NUM_FMT.format(v)
  return unit.includes('%') ? `${formatted} %` : formatted
}
